import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuBuilderService } from './menu-builder.service';

@NgModule({
    declarations: [],
    providers: [MenuBuilderService],
    imports: [CommonModule],
})
export class MenuBuilderModule {}
